function salesRepRate(rep, usdBase) {
    const directed = rep?.directedCommission || {}
    const threshold = Number(directed.threshold)
    const below = Number(directed.below)
    const atOrAbove = Number(directed.atOrAbove)
    if (threshold > 0 && below > 0 && atOrAbove > 0) {
        return Number(usdBase) >= threshold ? atOrAbove : below
    }
    if (below > 0) return below
    const plain = Number(rep?.commission)
    return plain > 0 ? plain : 0
}

export function quoteSalesRepIds(quote) {
    const ids = Array.isArray(quote?.salesRepIds)
        ? quote.salesRepIds.filter(Boolean)
        : []
    if (ids.length) return ids.slice(0, 2)
    const fromLines = []
    ;(quote?.commissions || []).forEach(row => {
        if (row?.salesRepId && !fromLines.includes(row.salesRepId)) {
            fromLines.push(row.salesRepId)
        }
    })
    return fromLines.slice(0, 2)
}

export function salesRepCommissionShare(reps, usdBase) {
    const list = (reps || []).filter(Boolean).slice(0, 2)
    if (!list.length) return []
    const rate = salesRepRate(list[0], usdBase)
    if (!(rate > 0)) return []
    const percentage =
        Math.round((list.length > 1 ? rate / 2 : rate) * 100) / 100
    return list.map(rep => ({
        details: rep.name || 'Sales rep',
        percentage,
        ...(rep.id ? { salesRepId: rep.id } : {}),
    }))
}

export function usdBaseBeforeCommission(costs) {
    return (costs || []).reduce((sum, cost) => {
        if (cost?.exportTariff) return sum + (Number(cost.salePrice) || 0)
        const marginPercentage = Number(cost.margin) / 100
        return sum + Number(cost.total) / (1 - marginPercentage)
    }, 0)
}

export function toUsdFromGlobal(amount, globalCurrency, rate) {
    if (!globalCurrency || globalCurrency === 'USD') return amount
    const value = Number(rate)
    return value > 1 ? amount / value : amount
}

export function commissionBaseUsd(costs, quote, settings) {
    const exchangeSetting = (settings || []).find(
        row => row?.name === 'Exchange'
    )
    const rate =
        quote?.currency === 'USD' && Number(quote.exchange) > 1
            ? Number(quote.exchange)
            : Number(
                  (exchangeSetting?.exchanges || []).find(
                      row => row.currency === 'USD'
                  )?.money
              )
    return toUsdFromGlobal(
        usdBaseBeforeCommission(costs),
        exchangeSetting?.globalCurrency,
        rate
    )
}

export function salesRepCommissionsManual(commissions) {
    return (commissions || []).some(row => row?.salesRepId && row.manual)
}

export function salesRepPercentKey(commissions) {
    return (commissions || [])
        .filter(row => row?.salesRepId)
        .map(row => `${row.salesRepId}:${Number(row.percentage)}`)
        .sort()
        .join('|')
}

export function mergeSalesRepCommissions(commissions, lines) {
    const rest = (commissions || []).filter(row => !row?.salesRepId)
    return [...rest, ...(lines || [])]
}

export function marginsForCommissions(costs, commissions, exchange) {
    let totalCommissionPercentage = 0
    if (commissions && commissions.length > 0) {
        totalCommissionPercentage = commissions.reduce(
            (sum, commission) => sum + parseFloat(commission.percentage),
            0
        )
    }
    return (costs || []).map(cost => {
        if (cost.exportTariff) return cost
        const marginPercentage = Number(cost.margin) / 100
        const salesPrice1 = Number(cost.total) / (1 - marginPercentage)
        const totalCommission = (
            salesPrice1 *
            (Number(totalCommissionPercentage) / 100)
        ).toFixed(2)
        const totalMargin = (salesPrice1 - Number(cost.total)).toFixed(2)
        const salePrice = parseFloat(
            (salesPrice1 + Number(totalCommission)).toFixed(2)
        )
        const total2 = parseFloat(
            (Number(cost.total) / Number(exchange)).toFixed(2)
        )
        const totalMargin2 = parseFloat(
            (Number(totalMargin) / Number(exchange)).toFixed(2)
        )
        const salePrice2 = parseFloat(
            (Number(salePrice) / Number(exchange)).toFixed(2)
        )
        const commission2 = parseFloat(
            (Number(totalCommission) / Number(exchange)).toFixed(2)
        )
        const pricePerQuantity = parseFloat(
            (salePrice / cost.quantity).toFixed(2)
        )
        const pricePerQuantity2 = parseFloat(
            (salePrice2 / cost.quantity2).toFixed(2)
        )
        return {
            id: cost.id,
            commission: parseFloat(totalCommission),
            totalMargin: parseFloat(totalMargin),
            salePrice,
            total2,
            totalMargin2,
            salePrice2,
            commission2,
            pricePerQuantity,
            pricePerQuantity2,
        }
    })
}
